import { z } from 'zod';

/**
 * §23.3 — SP-API kimlik bilgileri ekrandan giriliyor.
 *
 * Doğrulama biçime bakıyor, gerçekliğe değil: bir bilginin doğru olup olmadığı
 * ancak Amazon'a sorulunca belli oluyor. Buradaki kontroller yazım hatalarını
 * (boşluk, yarım yapıştırma) erken yakalamak için.
 */
export const spApiCredentialSchema = z.object({
  clientId: z
    .string()
    .trim()
    .min(10, 'Client ID çok kısa görünüyor — eksik yapıştırılmış olabilir.')
    .max(500, 'Client ID çok uzun görünüyor.')
    .regex(/^amzn1\./, 'Client ID "amzn1." ile başlamalı. Amazon\'un verdiği değeri olduğu gibi yapıştırın.'),
  clientSecret: z
    .string()
    .trim()
    .min(20, 'Client Secret çok kısa görünüyor — eksik yapıştırılmış olabilir.')
    .max(500, 'Client Secret çok uzun görünüyor.'),
  refreshToken: z
    .string()
    .trim()
    .min(20, 'Refresh Token çok kısa görünüyor — eksik yapıştırılmış olabilir.')
    .max(4000, 'Refresh Token çok uzun görünüyor.')
    .regex(/^Atzr\|/, 'Refresh Token "Atzr|" ile başlamalı.'),
  sellerId: z
    .string()
    .trim()
    .min(5, 'Satıcı kimliği çok kısa.')
    .max(64, 'Satıcı kimliği çok uzun.')
    .regex(/^[A-Z0-9]+$/, 'Satıcı kimliği yalnızca büyük harf ve rakam içerir.'),
  marketplaceId: z
    .string()
    .trim()
    .min(5, 'Pazaryeri kimliği çok kısa.')
    .max(64, 'Pazaryeri kimliği çok uzun.')
    .regex(/^[A-Z0-9]+$/, 'Pazaryeri kimliği yalnızca büyük harf ve rakam içerir.'),
  endpoint: z.string().trim().url('Geçerli bir adres girin.').optional(),
  lwaEndpoint: z.string().trim().url('Geçerli bir adres girin.').optional(),
});

export type SpApiCredentialInput = z.infer<typeof spApiCredentialSchema>;
